import React from 'react';
import { Card } from 'semantic-ui-react';
import ExpertCard from '../Experts/ExpertCard';

const ExpertCards = ({ experts, renderControls }) => (
  <Card.Group itemsPerRow={3} stackable>
    {experts.map((expert) => (
      <ExpertCard
        key={expert.id}
        expert={expert}
        adminControls={renderControls && renderControls(expert)}
      />
    ))}
  </Card.Group>
);

export default ExpertCards;
